/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Downgrade_CancelledInputs */



/**
* | output |
* | --- |
* | "Downgrade cancelled." |
*
* @param {Sub_Dashboard_Downgrade_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_downgrade_cancelled = /** @type {((inputs?: Sub_Dashboard_Downgrade_CancelledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Downgrade_CancelledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade abgebrochen.")
	return /** @type {LocalizedString} */ ("Downgrade cancelled.")
});